import { DefaultOptionType } from 'rc-select/lib/Select';

export interface PeriodOption extends DefaultOptionType {
  type: string;
}

export function filterAllowed(selected?: PeriodOption | PeriodOption[]) {
  // Only one predefine or multiple periods are valid - if new option is added to
  // the end, ensure that only one predefine or multiple periods are selected.
  const isArray = Array.isArray(selected);
  const last = isArray ? selected.at(-1) : selected;
  if (!last) {
    return [];
  }

  if (last.type === 'predefined' || !isArray) {
    return [last.value];
  }

  return selected
    .filter((option) => option.type === 'period')
    .map((option) => option.value);
}
